import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";
import { Template } from "./AdmissionApplicationTemplates";

/**
 * ### 待機者 API 操作クラス
 */
export default class WaiterChangeApplications {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET WaiterChangeApplications
   */
  public async get(userStore: LoginUser, residentIdInSystem: number): Promise<WaiterChangeApplicationsGetModel> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      residentIdInSystem: residentIdInSystem
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterChangeApplication, formatParams);
    const response = await this.commonService.executeGet<WaiterChangeApplicationsGetModel>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * ### PATCH WaiterChangeApplications
   */
  public async patch(userStore: LoginUser, residentIdInSystem: number, requestBody: WaiterChangeApplicationsPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      residentIdInSystem: residentIdInSystem
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterChangeApplication, formatParams);
    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * ### DELETE WaiterChangeApplications
   *
   * - DELETEだが、削除時のメッセージを送る必要があるので実際はPOSTリクエストする
   */
  public async delete(userStore: LoginUser, residentIdInSystem: number, requestBody: WaiterChangeApplicationsPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      residentIdInSystem: residentIdInSystem
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterChangeApplicationDelete, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface WaiterChangeApplicationsGetModel {
  /** システムで一意の利用者ID */
  residentIdInSystem: number;

  /** 変更前値 */
  beforeValue: Template;
  /** 変更後値 */
  afterValue: Template;
  /** 申請者の施設 ID */
  applicantFacilityId: number;
  /** 申請者のソートキー。residentsTBL の residentsSortKey */
  applicantSortKey: string;
  /** 取り下げ理由 */
  cancelReason: string;
  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 最終更新日 */
  updated: number;
  /** 作成した日付(YYYYMMDDhhmmssSSS) */
  created: number;
}

export interface WaiterChangeApplicationsPatchModel {
  /** 登録する変更後値 */
  value: Template;
  /** メッセージタイトル */
  messageTitle: string;
  /** メッセージ本文 */
  messageText: string;

  /** 最終更新日 */
  updated: number;
}

export interface WaiterChangeApplicationsPostModel {
  /** メッセージタイトル */
  messageTitle: string;
  /** メッセージ本文 */
  messageText: string;
}
